import {
  SET_LATEST_ROLES_DATA,
  SET_JOBTYPE_DATA,
  SET_METRICS_DATA,
  SET_DEGREE_CHART_DATA,
  SET_INSTITUTE_CHART_DATA,
  SET_LOCATION_CHART_DATA,
  SET_FINANCIAL_YEAR_DATA,
  SET_STAGES_CHART_DATA,
  SET_DEGREE_CHART_LOADING,
  SET_LOCATION_CHART_LOADING,
  SET_INSTITUTE_CHART_LOADING,
} from './actions'

const initialState = {
  latestRolesData: null,
  jobtypeData: null,
  metricsData: null,
  degreeChartData: null,
  instituteChartData: null,
  locationChartData: null,
  financialYearData: null,
  stagesChartData: null,
  degreeChartLoading: false,
  locationChartLoading: false,
  instituteChartLoading: false,
}

const corporateDashboardPage2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LATEST_ROLES_DATA:
      return {
        ...state,
        latestRolesData: action.data,
      }
    case SET_JOBTYPE_DATA:
      return {
        ...state,
        jobtypeData: action.data,
      }
    case SET_METRICS_DATA:
      return {
        ...state,
        metricsData: action.data,
      }
    case SET_DEGREE_CHART_DATA:
      return {
        ...state,
        degreeChartData: action.data,
      }
    case SET_INSTITUTE_CHART_DATA:
      return {
        ...state,
        instituteChartData: action.data,
      }
    case SET_LOCATION_CHART_DATA:
      return {
        ...state,
        locationChartData: action.data,
      }
    case SET_FINANCIAL_YEAR_DATA:
      return {
        ...state,
        financialYearData: action.data,
      }
    case SET_STAGES_CHART_DATA:
      return {
        ...state,
        stagesChartData: action.data,
      }
    case SET_DEGREE_CHART_LOADING:
      return {
        ...state,
        degreeChartLoading: action.loading,
      }
    case SET_LOCATION_CHART_LOADING:
      return {
        ...state,
        locationChartLoading: action.loading,
      }
    case SET_INSTITUTE_CHART_LOADING:
      return {
        ...state,
        instituteChartLoading: action.loading,
      }
    default:
      return state
  }
}

export default corporateDashboardPage2Reducer
